import { spacing } from '@thiememeulenhoff/lit-sdk';
import { BreakpointSmall } from '@thiememeulenhoff/tokens/core';
import { css, CSSResult, unsafeCSS } from 'lit';
import { tagName } from '../../../helpers/element.helper';

export const tag = tagName('toaster-stack');

const styles: Array<CSSResult> = [];

styles.push(css`
  :host([headerOffset]) {
    margin-block-start: ${spacing(1000)};
  }

  ::slotted(a-toaster-message) {
    margin-block-start: ${spacing(75)};
    pointer-events: auto;
  }

  :host(.float) {
    inset-block-end: 0;
    inset-block-start: var(--tm-header-height, 0);
    inset-inline-end: 0;
    overflow-x: hidden;
    overflow-y: auto;
    padding-block: ${spacing(150)};
    pointer-events: none;
    position: fixed;
    z-index: 900;
  }

  @media (width >= ${unsafeCSS(BreakpointSmall)}) {
    :host {
      padding-inline-end: ${spacing(150)};
    }
  }
`);

export const toasterStackStyles = styles;
